import { Flex } from "@/storybook-components";
import type { Projects } from "@/types";
import { useAppSelector } from "@/redux/store/hooks";
import Filter from "./menu-filter";
import { FINDER_WIDE } from "./breakpoints";

const Menu = ({ projects }: Projects): JSX.Element => {
  const { error, queryFilter } = useAppSelector((state) => state.projectFinder);

  const {
    showSearch,
    showTagsFilter,
    showStateFilter,
    showYearFilter,
    showResetFilter
  } = queryFilter;

  if (
    (!showSearch &&
      !showTagsFilter &&
      !showStateFilter &&
      !showYearFilter &&
      !showResetFilter) ||
    error
  ) {
    return null;
  }

  return (
    <Flex
      mb="7px"
      pb="5px"
      w="full"
      align="center"
      borderBottom="1px solid #f4f4f4"
      className="ehq-projectsMenuContainer"
      css={{
        flexDirection: "column",
        [FINDER_WIDE]: { flexDirection: "row" }
      }}
    >
      <Filter projects={projects} />
    </Flex>
  );
};

export default Menu;
